// extracted by mini-css-extract-plugin
export default {"littlePadding":"MainInfo_littlePadding__aXysa","field":"MainInfo_field__xWc8M","verification":"MainInfo_verification__0+WMw","formControllabel":"MainInfo_formControllabel__4RzN5"};